export default "__VITE_ASSET__CN60Ba0T__"